// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

export interface ExpressCheckoutCollectionModel {
    expressCheckout?: string;
    isLoading?: boolean;
    isCalled?: boolean;
    isEnabled?: boolean;
}

const expressCheckoutUrl = "api/rugby/expressCheckout";

export async function getExpressCheckout(parameter?: any) {
    const expressCheckoutCollection = await get<any>(expressCheckoutUrl, parameter);
    return expressCheckoutCollection;
}
